module.exports = __webpack_public_path__ + "static/media/cancelOrder.a344687d.svg";